module.exports = __webpack_public_path__ + "static/media/svg.07d50e2d.svg";